import { createContext } from 'react';

const crossMediaContext = createContext();

export default crossMediaContext;
